import React, { Fragment } from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';

import './not-applicable-cell-renderer.scss';
import { useTranslation } from 'react-i18next';

type Props = Partial<ICellRendererParams>;

const NotApplicableCellRenderer = ({ value, node }:Props): JSX.Element => {
  const { t } = useTranslation();

  if (node?.group) {
    return <span />;
  }

  if (value != null && value !== '') {
    return <Fragment>{value}</Fragment>;
  }

  return (
    <span className="not-applicable-cell-renderer">
      {t('common.grid.notApplicable')}
    </span>
  );
};

export default NotApplicableCellRenderer;
